import React, { ChangeEvent, useRef } from 'react'
import { t } from '@lingui/core/macro'
import styles from './InputForm.module.css'

interface InputFormProps {
    label: string
    type: string
    name: string
    value: string
    placeholder: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    maxLength?: number
    step?: number
    min?: number
    errorMessage?: string
    clearable?: boolean
}

const InputForm = (props: InputFormProps) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const handleClear = () => {
        props.onChange({ target: { name: props.name,  value: '' } } as ChangeEvent<HTMLInputElement>)
        inputRef.current?.focus()
    }

    return (
        <div className={styles.inputGroup}>
            <label className={styles.label}>{props.label}</label>
            <div className={styles.inputWrapper}>
                <input
                    ref={inputRef}
                    type={props.type}
                    name={props.name}
                    value={props.value}
                    placeholder={props.placeholder}
                    maxLength={props.maxLength}
                    step={props.step}
                    min={props.min}
                    className={`${styles.input} ${props.errorMessage ? styles.inputError : ''}`}
                    onChange={props.onChange}
                />
                {props.clearable && props.value && (
                    <button type="button" className={styles.clearButton} onClick={handleClear} aria-label={t`Очистить`}>
                        ×
                    </button>
                )}
            </div>
            {props.errorMessage && props.name !== 'amount' && <span className={styles.error}>{props.errorMessage}</span>}
        </div>
    )
}

export default InputForm
